module.exports = __webpack_public_path__ + "static/media/c3.e2b3fec0.png";